export function initHeaderScroll() {
  const header = document.querySelector('.l-header');
  if (!header) return;

  const update = () => {
    header.classList.toggle('is-scrolled', window.scrollY >= 60);
  };

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
}
